<div class="mydocma-dialog-container mm-kb-scroll-footer">
  <div *ngIf="!(appContainerService.mobileView$ | async); else mobileHeader" class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title"
         *ngIf="dialogData.config.selectedTemplate as t; else noTemplateHeader">
      {{'MM.reporting.writing.title' | translate}}:
      {{t.Number}} {{t.Number > 0 && t.Name1 ? '-' : ''}} {{t.Name1}}
    </div>
    <ng-template #noTemplateHeader>
      <div class="mydomca-dialog-header-title">
        {{'MM.reporting.writing.title' | translate}}
      </div>
    </ng-template>
    <div>
      <button mat-icon-button type="button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <div class="wt-dialog-content"
         [@.disabled]="isAnimationUnsupportedDevice"
         [class.anim-off]="isAnimationUnsupportedDevice"
         mydocmaResizeEvent
         (resize)="onResize($event)">
      <mydocma-loader class="mydocma-mm-loader" [size]="'middle'"
                      *ngIf="dialogData.service.loading$ | async"></mydocma-loader>
      <mydocma-mm-writing-stepper
        [@.disabled]="isAnimationUnsupportedDevice"
        [class.anim-off]="isAnimationUnsupportedDevice"
        #stepperComponent
        [reportConfig]="dialogData.config"
        [mobileMode]="mobileMode"
        >
      </mydocma-mm-writing-stepper>
    </div>
  </div>

  <div *ngIf="!(appContainerService.mobileView$ | async); else mobileFooter" class="mydocma-dialog-footer">
    <button
      mat-stroked-button
      *ngIf="dialogData.service.emailButtonVisible"
      type="submit" class="mydocma-btn"
      (click)="previewEmailBody()"
      [disabled]="dialogData.service.emailButtonDisabled"
      style="margin-right: 10px"
    >
      {{'MM.reporting.writing.buttons.emailPreview' | translate}}
    </button>
    <button mat-stroked-button type="submit" class="mydocma-btn" (click)="cancel()" style="margin-right: 10px">
      {{'MM.general.button.cancel' | translate}}
    </button>
    <button mat-stroked-button type="button" class="mydocma-btn-primary"

            [disabled]="!(dialogData.service.selectedTemplate$ | async)
      || !(dialogData?.service?.steperService?.currStep?.completed ?? false)
      || dialogData?.service?.nextButtonDisabled"

            (click)="next()">
      {{dialogData.service.nextButtonText }}
    </button>
  </div>

  <ng-template #mobileHeader>
    <div class="mydocma-dialog-header">
      <div class="mm-pane-header mydocma-detail-header" style="flex: 1 1 100%">
        <div class="mm-pane-header-title" style="display: block">
          <div class="mm-pane-header-text" *ngIf="dialogData.config.selectedTemplate as t; else noTemplateMobileHeader">
            {{'MM.reporting.writing.title' | translate}}:  {{t.Number}} - {{t.Name1}}
          </div>
        </div>

        <ng-template #noTemplateMobileHeader>
          <div class="mm-pane-header-title">
            <div class="mm-pane-header-text">
              {{'MM.reporting.writing.title' | translate}}
            </div>
          </div>
        </ng-template>

        <button
          style="display: block"
          mat-icon-button type="button" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #mobileFooter>
    <div class="mobile-pane-footer">
      <div style="margin-right: 10px">
        <button mat-stroked-button (click)="cancel()" class="mydocma-btn">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div style="margin-right: 10px">
        <button
          mat-stroked-button type="button"
          class="mydocma-btn-primary"

          [disabled]="!(dialogData.service.selectedTemplate$ | async)
      || !(dialogData?.service?.steperService?.currStep?.completed ?? false)"

          (click)="next()">
          {{dialogData.service.nextButtonText }}
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</div>
